import type { Store } from 'pinia'
import { createPinia, getActivePinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { onUnmounted } from 'vue'
import { PiniaSyncPlugin } from './plugins/sync'

export * from './exports'
export * from './models'

export { PiniaSyncPlugin } from './plugins/sync'

export function usePinia(pinia = createPinia()) {
  return pinia
    .use(PiniaSyncPlugin)
    .use(createPersistedState())
}

/** Disposes a pinia store */
export function disposeStore(store: Store) {
  const { $id } = store
  const pinia = getActivePinia()

  store.$dispose()

  // Delete default value
  if (pinia)
    delete pinia.state.value[$id]
}

export function disposeStoreOnUnmount(ref: Store | (() => Store)) {
  const store = typeof ref === 'function' ? ref() : ref

  if (!store.$id || !store.$dispose)
    throw new Error('disposeStoreOnUnmount: invalid store provided')

  onUnmounted(() => disposeStore(store))
}
